module.exports = __webpack_public_path__ + "assets/retina_3CirclesCDetailed.fba7354c3643ebef17a9681337c8b8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_3CirclesCDetailed.png
// module id = 598
// module chunks = 0